import { createContext, useContext, useState } from "react";

const PrivacyContext = createContext(null);

export function PrivacyProvider({ children }) {
  const [open, setOpen] = useState(false);
  return (
    <PrivacyContext.Provider value={{ open, openPolicy: () => setOpen(true), closePolicy: () => setOpen(false) }}>
      {children}
    </PrivacyContext.Provider>
  );
}

export const usePrivacy = () => useContext(PrivacyContext);
